import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
const fadeIn = keyframes `
  from { opacity: 0; }
  to { opacity: 1; }
`;
const slideUp = keyframes `
  from { opacity: 0; transform: translateY(20px) scale(0.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;
const Overlay = styled.div `
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  z-index: ${({ theme }) => theme.zIndex.modal};
  animation: ${fadeIn} 200ms ease;
`;
const sizeMap = {
    sm: '400px',
    md: '560px',
    lg: '720px',
    xl: '960px',
};
const ModalContainer = styled.div `
  background: ${({ theme }) => theme.colors.bg.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius['3xl']};
  width: 100%;
  max-width: ${({ size = 'md' }) => sizeMap[size]};
  max-height: calc(100vh - 2rem);
  overflow-y: auto;
  box-shadow: ${({ theme }) => theme.shadows['2xl']};
  animation: ${slideUp} 250ms ease;
`;
const ModalHeader = styled.div `
  padding: 1.5rem 1.5rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const ModalTitle = styled.h2 `
  font-size: 1.25rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
`;
const CloseButton = styled.button `
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.tertiary};
  padding: 0.25rem;
  border-radius: 0.375rem;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 150ms ease, background 150ms ease;
  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    background: ${({ theme }) => theme.colors.bg.tertiary};
  }
`;
const ModalBody = styled.div `
  padding: 1.5rem;
`;
export function Modal({ open, onClose, title, size = 'md', children }) {
    useEffect(() => {
        if (!open)
            return;
        const handler = (e) => {
            if (e.key === 'Escape')
                onClose();
        };
        document.addEventListener('keydown', handler);
        return () => document.removeEventListener('keydown', handler);
    }, [open, onClose]);
    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [open]);
    if (!open)
        return null;
    return createPortal(_jsx(Overlay, { onClick: onClose, children: _jsxs(ModalContainer, { size: size, onClick: (e) => e.stopPropagation(), children: [title && (_jsxs(ModalHeader, { children: [_jsx(ModalTitle, { children: title }), _jsx(CloseButton, { onClick: onClose, "aria-label": "Close modal", children: "\u2715" })] })), _jsx(ModalBody, { children: children })] }) }), document.body);
}
//# sourceMappingURL=Modal.js.map